import * as React from "react";
import {translate} from "react-i18next";
import i18n from "i18next";
import {Header} from "../../components/Header";
import TextBody from "../../components/TextBody";
import BottomBar from "../../components/BottomBar";
import TopNav from "../../components/TopNav";
import {Container,Row,Col} from "reactstrap";
import StatusOverview from "../../components/StatusBar";
import vodafoneLogo from "../../media/icons/vf-logo.png";
import {SpacerRow} from "../../components/SpacerRow";
import TextField from '@material-ui/core/TextField';
import {ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import {BrowserView,MobileView,isMobile} from "react-device-detect";
import InfoBlocks from "../../components/InfoBlocks";
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import moment from "moment";


class Stage12Validation extends React.Component {

    /**
     * constructor
     * @param props
     */
    constructor(props){
        super(props);
        this.isValidForm = -1;
        this.state = {
            contactInformation: props.contactInformation ? props.contactInformation : {},
        };

    }

    render() {

		/**
		 * Top Navigation / "Footer" Link
		 */
		const footerLnk = <TopNav
			buttonTextResource={"footer_link"}
			buttonOnClick={this.props.openTopNav}
		/>;

        const headerAndWelcomeText = <div>
            <Header
                textResource={"validation_title"}
                name={`${this.props.apiData.firstName} ${this.props.apiData.lastName} `}
            />
            <Row className={"padding-top-24-validation"}></Row>
            <TextBody
                textResource={"validation_body_1"}
            />
            <TextBody
                textResource={"validation_body_2"}
            />
        </div>;

        const statusBar = <StatusOverview
            showDescription={true}
        />;

        // click on button triggers this.props.validationCallback -> which can be found in MainPage.js "validationCallback"
        return <Container>
            <MobileView>
                <Row>
                    <Col xs={2} style={{marginTop:"15px"}}>
                        <img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
                    </Col>
                    {footerLnk}
                </Row>
                <Row className={"padding-top-24-validation"}></Row>
                <Row>
                    <Col xs={12}>
                        <Header textResource={"validation_title"} />
                    </Col>
                </Row>
                <Row className={"padding-top-24-validation"}></Row>
                <Row>
                    <Col xs={12}>
                        <TextBody
                            textResource={"validation_body_1"}
                        />
                    </Col>
                </Row>
                <Row className={"padding-top-24-validation"}></Row>
                <Row>
                    <Col xs={12}>
                        <TextBody
                            textResource={"validation_body_2"}
                        />
                    </Col>
                </Row>
                <Row className={"padding-top-24-validation"}></Row>
               <Row>
                    <Col xs={12}>
                        <strong>
                            <TextBody
                                textResource={"validation_label_phone"}
                            />
                        </strong>

                            <TextBody
                                textResource={this.state.contactInformation.phoneNumber ? this.state.contactInformation.phoneNumber : ""}
                            />
                    </Col>
                    <Col xs={12} className={"margin-16"}>
                        <strong>
                            <TextBody
                                textResource={"validation_label_name"}
                            />
                        </strong>
                        <TextBody
                            textResource={`${this.props.apiData.firstName} ${this.props.apiData.lastName} `}
                        />
                    </Col>
               </Row>
                <span class="small">
                    <Row className={"margin-5"} />
                    <BottomBar
                        showFullWidth={true}
                        mainButtonOnClick={() => {
                            this.props.validationCallback(1);
                        }}
                        mainButtonTextResource={"validation_button_valid_text"}
                    />
                    <BottomBar
                        showBackButtonValidation={true}
                        showFullWidth={true}
						mainButtonOnClick={() => {
							this.props.validationCallback(0);
						}}
						backButtonValidationOnClick={true}
                        backValidationButtonTextResource={"validation_button_invalid_text"}
                    />
                    <Row className={"padding-top-24-validation"}></Row>
                    <Row>
                        <Col xs={12}>
                            <TextBody
                                textResource={"validation_fine_print"}
                            />
                        </Col>
                    </Row>
                </span>

            </MobileView>
            <BrowserView>
                <Row>
                    {footerLnk}
                </Row>
                <Container>
                    <Row>
                        <Col xs={2} style={{marginTop:"15px", height:"68px"}}>

                        </Col>
                    </Row>
                    <Row>
                        <Col xs={{size: 11, offset: 1}}>
                            <Row className={"padding-top-24-validation"}></Row>
                            <Row>
                                <Col xs={12}>
                                    <Header textResource={"validation_title"} />
                                </Col>
                            </Row>
                            <Row className={"padding-top-24-validation"}></Row>
                            <Row>
                                <Col xs={12}>
                                    <TextBody
                                        textResource={"validation_body_1"}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <TextBody
                                        textResource={"validation_body_2"}
                                    />
                                </Col>
                            </Row>
                            <Row className={"padding-top-24-validation"}></Row>
                            <Row>
                                <Col xs={6}>
                                    <p>
                                        <strong>
                                            <TextBody
                                                textResource={"validation_label_phone"}
                                            />
                                        </strong>
                                    </p>
                                    <p>
                                        <TextBody
                                            textResource={this.state.contactInformation.phoneNumber ? this.state.contactInformation.phoneNumber : ""}
                                        />
                                    </p>
                                </Col>
                                <Col xs={6}>
                                    <p>
                                        <strong>
                                            <TextBody
                                                textResource={"validation_label_name"}
                                            />
                                        </strong>
                                    </p>
                                    <p>
                                        <TextBody
                                            textResource={`${this.props.apiData.firstName} ${this.props.apiData.lastName} `}
                                        />
                                    </p>
                                </Col>
                            </Row>
                            <Row className={"padding-top-24-validation"}></Row>
                            <Row>
                                <Col xs={6} className={"small"}>
                                        <BottomBar
                                            showFullWidth={true}
                                            mainButtonOnClick={() => {
                                                this.props.validationCallback(1);
                                            }}
                                            mainButtonTextResource={"validation_button_valid_text"}
                                        />
                                </Col>
                                <Col xs={6} className={"small"}>
                                        <BottomBar
                                            showBackButtonValidation={true}
                                            showFullWidth={true}
                                            mainButtonOnClick={() => {
                                                this.props.validationCallback(0);
                                            }}
                                            backButtonValidationOnClick={true}
                                            backValidationButtonTextResource={"validation_button_invalid_text"}
                                        />
                                </Col>
                            </Row>
                            <Row className={"padding-top-24-validation"}></Row>
                            <Row>
                                        <Col xs={12}>
                                            <TextBody
                                                textResource={"validation_fine_print"}
                                            />
                                        </Col>
                                    </Row>
                        </Col>
                    </Row>
                </Container>
            </BrowserView>
        </Container>
    }
}

export default translate("translations")(Stage12Validation);